import React from 'react'
import { search } from '../actions/filter/search.js'

export const NaturalHOC = ComposedComponent => class extends React.Component {
  static displayName = 'ComponentNaturalHOC';

  componentDidMount () {
    if (this.props.Natural.length === 0)
      setTimeout(() => {search(`/leathers`, this.props.addNatural, this.props)}, 10)
  }

  render () {
    return <ComposedComponent {...this.props} {...this.state} />;
  }
}
